import { useEffect } from "react";
import { acquireCreditsRealtime } from "@/lib/credits-realtime";

export const CREDITS_CHANGED_EVENT = "flow:credits-changed";

export function notifyCreditsChanged(orgId: string | null) {
  if (!orgId || typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CREDITS_CHANGED_EVENT, { detail: { orgId } }));
}

export function useCreditsChanged(orgId: string | null, onChange: () => void) {
  useEffect(() => {
    if (!orgId) return;
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ orgId?: string }>).detail;
      if (!detail?.orgId || detail.orgId === orgId) onChange();
    };
    window.addEventListener(CREDITS_CHANGED_EVENT, handler);
    return () => window.removeEventListener(CREDITS_CHANGED_EVENT, handler);
  }, [orgId, onChange]);

  useEffect(() => {
    if (!orgId) return;
    return acquireCreditsRealtime(orgId, notifyCreditsChanged);
  }, [orgId]);
}
